var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPrev(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 5,
    fill: "#F1F4F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5581 22.4421L27.6858 16.7333C27.8902 16.5445 27.9949 16.3071 27.9998 16.0212C28.0045 15.7356 27.8998 15.4939 27.6858 15.2962C27.4714 15.0987 27.2118 15 26.9068 15C26.6018 15 26.3421 15.0987 26.1278 15.2962L18.3779 21.5794C18.2397 21.7071 18.1421 21.8417 18.0852 21.9833C18.0283 22.1249 17.9998 22.2778 17.9998 22.4421C17.9998 22.6064 18.0283 22.7593 18.0852 22.9009C18.1421 23.0425 18.2397 23.1771 18.3779 23.3048L26.1208 29.7101C26.3255 29.8987 26.5828 29.9953 26.8927 29.9999C27.2024 30.0042 27.4644 29.9076 27.6787 29.7101C27.8928 29.5124 27.9998 29.2729 27.9998 28.9916C27.9998 28.7103 27.8928 28.4707 27.6787 28.273L20.5581 22.4421Z",
    fill: "#A5A5A5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPrev);
export default __webpack_public_path__ + "static/media/icon_prev.8b9c4550b52735ecb269546623c78e12.svg";
export { ForwardRef as ReactComponent };